<template>
  <div class="tasks">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />
    <TaskTable :isReadOnly="isReadOnly" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumbs from '@/components/Breadcrumbs';
import TaskTable from '@/components/TaskTable';
import { coversAccessLevel } from '@/helpers/accessLevel';
import { TASKS_ACCESS_NODE } from '@/navigation/accessNodes';

export default {
  name: 'Tasks',
  components: {
    Breadcrumbs,
    TaskTable,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['getAccessLevel']),
    /** Viewer lists the tasks, but cannot edit, create or delete. */
    isReadOnly() {
      return !coversAccessLevel(this.getAccessLevel(TASKS_ACCESS_NODE), 'editor');
    },
    breadcrumbs() {
      return [{ name: 'Home', route: { name: 'home' } }, { name: this.$t('tasks') }];
    },
  },

  methods: {},

  async mounted() {},
};
</script>

<style scoped lang="scss"></style>
